import axiosInstance from "./axios.instance";
import { saveAs } from "file-saver";

// apies calls for company

const API_GET_COMPANY = async (companyId) => {
  try {
    const resp = await axiosInstance.get(`/company/${companyId}`);
    return resp.data;
  } catch (err) {
    throw err;
  }
};
const API_ADD_COMPANY = async (configData) => {
  try {
    const resp = await axiosInstance.post(`/company`, configData);
    return resp.data;
  } catch (err) {
    throw err;
  }
};
const API_PUT_COMPANY = async (companyId, updatedData) => {
  try {
    const resp = await axiosInstance.put(`/company/${companyId}`, updatedData);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_DELETE_COMPANY = async (companyId) => {
  try {
    const resp = await axiosInstance.delete(`/company/${companyId}`);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_ALL_COMPANIES = async (search) => {
  try {
    if (search) {
    }
    const resp = await axiosInstance.get(
      `/admin/companies${search ? "?companyName=" + search : ""}`
    );
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_GET_COMPANYBYID = async (companyId) => {
  try {
    const resp = await axiosInstance.get(`/admin/company/${companyId}`);
    return resp.data;
  } catch (error) {
    throw error;
  }
};
const API_GET_APP_INFO = async (companyId) => {
  try {
    const resp = await axiosInstance.get(`/admin/company/${companyId}/get-app-info`);
    return resp.data;
  } catch (error) {
    throw error;
  }
};
const API_GET_WABAHEALTH = async (companyId) => {
  try {
    const resp = await axiosInstance.get(
      `/admin/company/${companyId}/wabahealth`
    );
    return resp?.data;
  } catch (error) {
    console.log("error here");
    return {};
  }
};

const API_GET_SUBSCRIPTION = async (companyId) => {
  try {
    const resp = await axiosInstance.get(
      `/admin/company/${companyId}/subscription`
    );
    return resp?.data;
  } catch (error) {
    console.log("error here");
    return {};
  }
};

const API_GET_USERS = async (companyId) => {
  try {
    const resp = await axiosInstance.get(`/admin/company/${companyId}/users`);
    return resp?.data;
  } catch (error) {
    console.log("error here");
    return {};
  }
};

const API_GET_BILL_INFO = async (companies, from, to) => {
  try {
    var payload = {
      companies,
      from,
      to,
    };
    const resp = await axiosInstance.post(
      `/admin/companies/getBillingInfo`,
      payload
    );
    return resp?.data;
  } catch (error) {
    console.log("error : ", error);
    return [];
  }
};

const API_GET_BILl_BASIC_EXCEL = async (companies, from, to, fileName) => {
  try {
    fileName = fileName ? fileName : "BillInfo";
    var today = new Date();
    var payload = {
      companies,
      from,
      to,
    };
    const resp = await axiosInstance.post(
      `/admin/companies/getbillinginfo/basicexcel`,
      payload,
      { responseType: "blob" }
    );
    //console.log(resp);
    const blob = new Blob([resp.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, fileName + "-Basic-" + today.toLocaleDateString() + ".xlsx"); // Specify file name here
    return resp;
  } catch (error) {
    console.log("error : ", error);
    return [];
  }
};

const API_GET_BILl_INDETAIL_EXCEL = async (companies, from, to, fileName) => {
  try {
    fileName = fileName ? fileName : "BillInfo";
    var today = new Date();
    var payload = {
      companies,
      from,
      to,
    };
    const resp = await axiosInstance.post(
      `/admin/companies/getbillinginfo/indetailexcel`,
      payload,
      { responseType: "blob" }
    );
    //console.log(resp);
    const blob = new Blob([resp.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(
      blob,
      fileName + "-Detailed-" + today.toLocaleDateString() + ".xlsx"
    ); // Specify file name here
    return resp;
  } catch (error) {
    console.log("error : ", error);
    return [];
  }
};

const API_INITIATE_ONBOARDING = async (onboardingData) => {
  try {
    const resp = await axiosInstance.post(
      `/admin/company/onboardIgaminAccount`,
      onboardingData
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};

const API_ADD_NEW_COMPANY = async (companyData) => {
  try {
    const resp = await axiosInstance.post(
      `/admin/company/onboardCompany`,
      companyData
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};

const API_CHECK_FB_STATUS = async (statusData) => {
  try {
    const resp = await axiosInstance.post(
      `/admin/company/checkFbStatus`,
      statusData
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};

const API_ADD_SUBSCRIPTION = async (subscriptionData) => {
  try {
    const resp = await axiosInstance.post(
      `/support/subscription`,
      subscriptionData
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};
const API_UPGRADE_SUBSCRIPTION = async (subscriptionData) => {
  try {
    const resp = await axiosInstance.post(
      `/support/upgrade/subscription`,
      subscriptionData
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};
// PUT: Update user limit for a specific company (id = 2)
const API_UPDATE_USER_LIMIT = async (companyId, userLimitData) => {
  try {
    const resp = await axiosInstance.put(
      `/userlimit/${companyId}`,
      userLimitData
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};

// GET: Fetch user limit info for company (id = 2)
const API_GET_USER_LIMIT = async (companyId) => {
  try {
    const resp = await axiosInstance.get(
      `/admin/company/${companyId}/userlimit`
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};

export {
  API_ADD_COMPANY,
  API_DELETE_COMPANY,
  API_GET_COMPANY,
  API_PUT_COMPANY,
  API_ALL_COMPANIES,
  API_GET_WABAHEALTH,
  API_GET_COMPANYBYID,
  API_GET_SUBSCRIPTION,
  API_GET_USERS,
  API_GET_BILL_INFO,
  API_GET_BILl_BASIC_EXCEL,
  API_GET_BILl_INDETAIL_EXCEL,
  API_INITIATE_ONBOARDING,
  API_ADD_SUBSCRIPTION,
  API_CHECK_FB_STATUS,
  API_GET_USER_LIMIT,
  API_UPDATE_USER_LIMIT,
  API_UPGRADE_SUBSCRIPTION,
  API_GET_APP_INFO,
  API_ADD_NEW_COMPANY,
};
